import React, {Fragment} from "react";
import {
    Button,
    Col,
    Collapse,
    Descriptions,
    Divider,
    Dropdown,
    List,
    Menu,
    Popconfirm,
    Row,
    Space,
    Tag,
    Tooltip, Typography
} from "antd";
import PermissionHidden from "../../../../components/permissions/PermissionHidden";
import {
    AlertOutlined,
    CommentOutlined,
    CreditCardOutlined,
    DeleteOutlined, EditOutlined,
    EnvironmentOutlined, FieldTimeOutlined, FileOutlined,
    HomeOutlined,
    HourglassOutlined,
    InfoCircleOutlined,
    LinkOutlined,
    MailOutlined,
    MergeCellsOutlined, MinusCircleOutlined,
    NodeIndexOutlined,
    PhoneOutlined,
    PlusOutlined, ReloadOutlined,
    RollbackOutlined, ScheduleOutlined,
    SkinOutlined,
    TagOutlined, VerticalAlignBottomOutlined
} from "@ant-design/icons";
import RestrictedHidden from "../../../../components/permissions/RestrictedHidden";
import {checkForfait} from "../../../../components/permissions/functions";
import {APP_PREFIX_PATH, ASSET_BASE_URL} from "../../../../configs/AppConfig";
import ContactIcon from "../../../../components/util-components/ContactIcon";
import moment from "moment";

const {Text, Title} = Typography

export class FicheActions extends React.Component {


    render() {
        const {selected, fiche} = this.props

        if (!selected) {
            return null
        }

        return (
            <Row style={{justifyContent: "flex-end", marginBottom: 10}}>
                <Space>

                    <Tooltip placement="top" title="Interactions">
                        <Button onClick={() => fiche.modalActivity.show(selected.id)} type="text"
                                icon={<FieldTimeOutlined/>}/>
                    </Tooltip>


                    <Tooltip placement="top" title="Promesses de don">
                        <Button type={"text"}
                                href={APP_PREFIX_PATH + "/promesses/list/?search=" + selected.id}
                                target="_blank" icon={<HourglassOutlined/>}/>
                    </Tooltip>

                    <Tooltip placement="top" title="Paiements Récurrents">
                        <Button type={"text"}
                                href={APP_PREFIX_PATH + "/paiements/recurrent/?search=" + selected.id}
                                target="_blank" icon={<ReloadOutlined/>}/>
                    </Tooltip>

                    <Tooltip placement="top" title="Paiements">
                        <Button type={"text"}
                                href={APP_PREFIX_PATH + "/paiements/list/?search=" + selected.id}
                                target="_blank" icon={<VerticalAlignBottomOutlined/>}/>
                    </Tooltip>


                    <RestrictedHidden type="AUTH"
                                      condition={(i) => i.key == "Forfait" && ["CRM", "COM", "FULL"].includes(i.value)}>
                        <Tooltip placement="top" title="Rappels">
                            <Button type={"text"}
                                    href={APP_PREFIX_PATH + "/rappel/?contact=" + selected.id}
                                    target="_blank" icon={<AlertOutlined/>}/>
                        </Tooltip>

                        {/*

                        <Tooltip placement="top" title="Rendez Vous">
                            <Button type={"text"}
                                    href={APP_PREFIX_PATH + "/rdv/list?contact=" + selected.id}
                                    target="_blank" icon={<ScheduleOutlined/>}/>
                        </Tooltip>
                        */}


                    </RestrictedHidden>


                </Space>
            </Row>
        )
    }
}
